import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useDynamicListOptions } from './useDynamicListOptions';
import { useListTypeOptions, useOptionsList } from './useOptionsList';
import { ParentContext } from '../../ParentContext';
import _ from 'lodash'
import { dynListTypes } from 'global/enums/globalEnums';

const _basicTypes = ['dropdown', 'select', 'text', 'input', 'checkbox']
const _listTypes = ['dropdown', 'select']

export const useFormOptions = ({
  localData,
  currentGroup,
  currentViProps,
  groupItems,
  pageView
}) => {

  const [currentData, setCurrentData] = useState(() => localData);

  const propGroups = {
    grouped: _.groupBy(groupItems, item =>
      item?.data?.formItemType
    ),
    withListType: _.pickBy(groupItems, item =>
      item?.data?.listType
    ),
    withList: _.pickBy(groupItems, item =>
      _listTypes.includes(item?.data?.formItemType)
    ),
    nonClassic: _.pickBy(groupItems, function (item) {
      if (item?.data?.formItemType && !_basicTypes.includes(item?.data?.formItemType)) {
        return item.data.formItemType
      }
    }),
    withDynList: _.filter(groupItems, function (item) {
      if (dynListTypes[item?.data?.listType]) {
        return item.data.listType
      }
    })
  }

  useEffect(() => {
    setCurrentData(localData)
  }, [localData]);

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const { currentViPropList, currentCollectionPropList } = useMemo(() => {
    return getCurrentViPropList(currentData, aps_viewItems, currentGroup, pageView);
  }, [currentData, pageView]);

  const optionsList_dyn = useDynamicListOptions({ groupItems, localData: currentData, currentViPropList, currentCollectionPropList, currentViProps })
  const optionsList = useOptionsList({ viewProps: propGroups?.withListType })
  const altList = useListTypeOptions({ viewProps: propGroups?.withListType })

  const formOptions = useMemo(() => {
    const _optionsList = _.merge({}, optionsList, optionsList_dyn, altList)
    return _optionsList
  }, [optionsList_dyn, optionsList, altList])

  return formOptions
}

const getCurrentViPropList = (currentData, aps_viewItems, currentGroup, pageView) => {

  let currentViPropList = null
  let currentCollectionPropList = null

  const { captionPage, dataCollectionName } = currentData ?? {}

  let _vit = pageView

  if (dataCollectionName) { _vit = dataCollectionName }

  if (aps_viewItems && _vit && aps_viewItems[_vit]) {
    let currentVi = aps_viewItems[_vit]
    const { altCollectionName } = currentVi ?? {}
    if (altCollectionName && aps_viewItems[altCollectionName]) {
      currentVi = aps_viewItems[altCollectionName]
    }
    const { props: props_vi, propsAdditional } = currentVi ?? {}
    const { ignoreItemStatus, showPdf } = propsAdditional ?? {}
    // if (useItemStatus && !ignoreItemStatus && isDataItem && !ignoreItemStatus_p) { props_vi['itemStatusType'] = {} }
    // if (useItemTimezone && !ignoreItemStatus && isDataItem && !ignoreItemStatus_p) { props_vi['itemStatusType'] = {} }
    // if (showPdf) { props_vi['itemPdf'] = {} }
    currentViPropList = props_vi
  }

  if (captionPage && aps_viewItems && aps_viewItems[captionPage]) { _currentCollectionPropList = aps_viewItems[captionPage].props }
  // if (menu && menu.captionPage && aps_viewItems && aps_viewItems[menu.captionPage]) { _currentCollectionPropList = aps_viewItems[menu.captionPage].props }

  return { currentViPropList, currentCollectionPropList }

}
